import axios from '../utils/axios';

export default function update(adminId, id, data) {
    return (
        axios.post(`/admin/${adminId}/search/query-report/${id}`,  data )
    )
}
